module.exports = "/images/ny-life2-16.jpg";